import { render, staticRenderFns } from "./AuditPendenciesValueMore.vue?vue&type=template&id=dc3e6442&scoped=true"
import script from "./AuditPendenciesValueMore.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesValueMore.vue?vue&type=script&lang=js"
import style0 from "./AuditPendenciesValueMore.vue?vue&type=style&index=0&id=dc3e6442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3e6442",
  null
  
)

export default component.exports